module.exports = __webpack_public_path__ + "img/tryher-card-basic.60dc32c9.png";